import { apiFetch } from "../api/client";
import React, { useState } from "react";
import {
  getExplicitSelectedCompanyId,
} from "../utils/tenantContext";

function PenTestForms({ engagements, onSaved }) {
  const [engagement, setEngagement] = useState({
    name: "",
    client_name: "",
    authorized_by: "",
    tester_name: "",
    rules_of_engagement: "",
    scope_summary: "",
    status: "Active",
  });

  const [target, setTarget] = useState({
    target_type: "Windows Host",
    hostname: "",
    ip_address: "",
    device_uuid: "",
    approved_ports: "",
    owner: "",
    status: "In Scope",
  });

  async function createEngagement() {
    const companyId =
      getExplicitSelectedCompanyId();

    if (!companyId) {
      window.alert(
        "Select a tenant before creating an engagement."
      );
      return;
    }

    try {
      const response = await apiFetch(
        `/pentest/engagements?company_id=${encodeURIComponent(
          companyId
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(engagement),
        }
      );

      if (!response.ok) {
        let detail =
          `Unable to create engagement. Status ${response.status}.`;

        try {
          const data = await response.json();
          detail =
            data?.detail ||
            data?.message ||
            detail;
        } catch {
          // Non-JSON error body.
        }

        throw new Error(detail);
      }

      onSaved();
    } catch (error) {
      console.error(
        "Pen Test engagement creation error:",
        error
      );

      window.alert(
        error.message ||
          "Unable to create Pen Test engagement."
      );
    }
  }

  async function createTarget() {
    const companyId =
      getExplicitSelectedCompanyId();

    if (!companyId) {
      window.alert(
        "Select a tenant before creating a target."
      );
      return;
    }

    const engagementId =
      engagements?.[0]?.id;

    if (!engagementId) {
      window.alert(
        "Create or select an engagement before adding a target."
      );
      return;
    }

    try {
      const response = await apiFetch(
        `/pentest/targets?company_id=${encodeURIComponent(
          companyId
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...target,
            engagement_id: engagementId,
          }),
        }
      );

      if (!response.ok) {
        let detail =
          `Unable to create target. Status ${response.status}.`;

        try {
          const data = await response.json();
          detail =
            data?.detail ||
            data?.message ||
            detail;
        } catch {
          // Non-JSON error body.
        }

        throw new Error(detail);
      }

      onSaved();
    } catch (error) {
      console.error(
        "Pen Test target creation error:",
        error
      );

      window.alert(
        error.message ||
          "Unable to create Pen Test target."
      );
    }
  }

  return (
    <section className="pentest-form-grid">
      <div className="scope-card">
        <h2>Create Engagement</h2>

        <input placeholder="Engagement Name" onChange={(e) => setEngagement({ ...engagement, name: e.target.value })} />
        <input placeholder="Client Name" onChange={(e) => setEngagement({ ...engagement, client_name: e.target.value })} />
        <input placeholder="Authorized By" onChange={(e) => setEngagement({ ...engagement, authorized_by: e.target.value })} />
        <input placeholder="Tester Name" onChange={(e) => setEngagement({ ...engagement, tester_name: e.target.value })} />

        <textarea placeholder="Rules of Engagement" onChange={(e) => setEngagement({ ...engagement, rules_of_engagement: e.target.value })} />
        <textarea placeholder="Scope Summary" onChange={(e) => setEngagement({ ...engagement, scope_summary: e.target.value })} />

        <button className="report-btn" onClick={createEngagement}>Create Engagement</button>
      </div>

      <div className="scope-card">
        <h2>Add Target</h2>

        <input placeholder="Hostname" onChange={(e) => setTarget({ ...target, hostname: e.target.value })} />
        <input placeholder="IP Address" onChange={(e) => setTarget({ ...target, ip_address: e.target.value })} />
        <input placeholder="Device UUID" onChange={(e) => setTarget({ ...target, device_uuid: e.target.value })} />
        <input placeholder="Approved Ports e.g. 135,445,3389" onChange={(e) => setTarget({ ...target, approved_ports: e.target.value })} />
        <input placeholder="Owner" onChange={(e) => setTarget({ ...target, owner: e.target.value })} />

        <button className="report-btn" onClick={createTarget}>Add Target</button>
      </div>
    </section>
  );
}

export default PenTestForms;
